import React, { useEffect, useState } from 'react'
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import DataLoader from '../../../Utils/DataLoader';
import { useSelector } from 'react-redux';
import { apiData } from '../../../actions';


export default function HomeRelaxingBeach() {
    const [relaxingData, setRelaxingData] = useState([]);
    const [pageLoading, setPageLoading] = useState(true);

    const place = useSelector((state) => state.place);

    const GetCities = async () => {
        try {
            setPageLoading(true);
            let apiRes = await apiData.RelaxingCities();

            if (apiRes?.status >= 200 && apiRes?.status <= 399) {
                setRelaxingData(apiRes?.data?.data || []);
            } else {
                console.log("API error");
            }
        } catch (err) {
            console.log("Relaxing Cities Error:", err);
        }
    };

    useEffect(() => {
        async function loadAllData() {
            try {
                await GetCities();
            } catch (err) {
                console.log("Page loading error:", err);
            } finally {
                setPageLoading(false);
            }
        }

        loadAllData();
    }, [place]);

    if (pageLoading) {
        return <DataLoader />;
    }

    return (
        <section className="section-equal-padding bg-white">
            <div className="container-fluid">
                <div
                    className="row mb-3 mb-md-5"
                    uk-scrollspy="cls: uk-animation-slide-bottom; delay: 400; repeat: false"
                >
                    <div className="col-md-6">
                        <div className="section-top-heading">
                            <h2>Relaxing Beach Gateways</h2>
                        </div>
                    </div>

                    <div className="col-md-6">
                        <div className="section-top-heading">
                            <p>
                                Get set for an incredible journey with our relaxing beach
                                gateways! Enjoy peace, beauty, and unforgettable experiences.
                            </p>
                        </div>
                    </div>
                </div>

                {/* BEACH CAROUSEL */}
                <Swiper
                    modules={[Navigation, Autoplay]}
                    spaceBetween={20}
                    loop={true}
                    autoplay={{
                        delay: 3000,
                        disableOnInteraction: false,
                    }}
                    navigation={true}
                    breakpoints={{
                        0: { slidesPerView: 1 },
                        768: { slidesPerView: 2 },
                        992: { slidesPerView: 3 },
                        1400: { slidesPerView: 4 },
                    }}
                    className="excitement-swiper pb-70"
                    uk-scrollspy="cls: uk-animation-slide-bottom; delay: 400; repeat: false"
                >
                    {relaxingData.map((ele, index) => (
                        <SwiperSlide key={index}>
                            <div className="beach-card-box">
                                <a href={ele?.url} target="_blank" rel="noreferrer">
                                    <figure>
                                        <img
                                            loading="lazy"
                                            src={ele?.image_url}
                                            alt={ele?.name || "Beach"}
                                        />
                                    </figure>

                                    <div className="beach-content-area p-3">
                                        <h5>
                                            {ele?.name
                                                ? ele.name.length > 18
                                                    ? ele.name.slice(0, 18) + "..."
                                                    : ele.name
                                                : "Unknown Location"}
                                        </h5>

                                        <p>
                                            {ele?.description
                                                ? ele.description.slice(0, 55) + "..."
                                                : "Beautiful relaxing destination..."}
                                        </p>
                                    </div>
                                </a>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </section>
    );
}